
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const trackinginfoApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listTrackingInfos: builder.query ({
      query: (params) => `v2/trackinginfo/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["TrackingInfo"]
    }),
    getTrackingInfo: builder.query ({
      query: (trackinginfo_id) => `v2/trackinginfo/${trackinginfo_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["TrackingInfo"]
    }),

    updateTrackingInfo: builder.mutation ({
      query: ({trackinginfo_id, data}) => ({
        url: `v2/trackinginfo/${trackinginfo_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["TrackingInfo"]
    }),
    deleteTrackingInfo: builder.mutation ({
      query: (trackinginfo_id) => ({
        url: `v2/trackinginfo/${trackinginfo_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["TrackingInfo"]
    }),
    createTrackingInfo: builder.mutation ({
      query: (data) => ({
        url: `v2/trackinginfo/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["TrackingInfo"]
    }),
  })
})


export const {
  useListTrackingInfosQuery,
  useLazyListTrackingInfosQuery,
  useGetTrackingInfoQuery,
  useLazyGetTrackingInfoQuery,

  useUpdateTrackingInfoMutation,
  useDeleteTrackingInfoMutation,
  useCreateTrackingInfoMutation
} = trackinginfoApi
